<template>
    <div class="md-layout md-alignment-center-center">
        <toolbar title="Liste des employés" isAdd="true" @add="navigateTo({ name: 'employee_Edit', params: { id: 0 } })" class="md-layout md-layout-item md-size-100">
        </toolbar>

        <switchLayout storageKey="EmployeeListLayout" class="md-layout md-layout-item md-size-90">
            <template #list>
                <md-table md-card class="md-layout-item">
                    <md-table-row class="md-layout-item md-size-90">
                        <md-table-head>Nom</md-table-head>
                        <md-table-head class="md-small-hide">Engagé le</md-table-head>
                    </md-table-row>
                    <md-table-row v-for="(item, index) in items" :index="index" :key="index" @click="navigateTo({ name: 'employee_Item', params: { id: item.id } })">
                        <md-table-cell>{{ item.nickName }}</md-table-cell>
                        <md-table-cell class="md-small-hide">{{ item.hiredOn | YYYYMMDD }}</md-table-cell>
                    </md-table-row>
                </md-table>
            </template>
            <template #card>
                <md-card md-with-hover class="md-layout-item md-size-17 md-large-size-30 md-medium-size-45 md-small-size-100" v-for="(item, index) in items" :index="index" :key="index">
                    <div class="md-layout-item md-alignment-top-left" @click="navigateTo({ name: 'employee_Item', params: { id: item.id } })">
                        <div class="md-layout-item md-size-90">
                            <md-card-header>
                                <div class="md-layout-item md-size-45">
                                    <md-avatar class="md-avatar-icon md-large md-primary">
                                        <img v-if="item.picture" :src="item.picture" />
                                        <md-icon v-else>group</md-icon>
                                    </md-avatar>
                                </div>
                                <md-card-header-text class="md-title md-alignment-center-right">{{item.nickName }}</md-card-header-text>
                            </md-card-header>
                        </div>
                        <md-card-content>
                            <p class="md-layout-item ">
                                <strong>Engagé le: </strong>{{item.hiredOn | YYYYMMDD}}
                            </p>
                        </md-card-content>
                    </div>
                </md-card>
            </template>
        </switchLayout>        

        <partialListNavigation v-if="range" v-bind:response.sync="response" @more="more" class="md-layout md-layout-item md-size-100" />
    </div>
</template>

<script>
    import baseToolbar from '@/components/toolbarBase.vue';
    import partialListNavigation from '@/components/partialListNavigation.vue';
    import switchLayout from '@/components/switchLayout.vue';

    import { apiExtension } from '@/mixins/apiExtension.js';
    import { navigateRouteExtension } from '@/mixins/navigateRouteExtension.js';

    export default {
        name: 'employeeList',
        mixins: [apiExtension, navigateRouteExtension],
        data: () => ({
            items: [],
            range: null,
            response: null,
        }),

        mounted:
            function () {
                this.dataRead();
            },

        methods: {
            dataRead: async function () {

                let data = await this.httpApiGet('employees');
                if (data) { 
                    this.items = data; 
                }
            },
            callback: function (response) {
                this.response = response;
                this.range = $App.getRangeHeader(response);
            },
            more: function () {
                this.dataRead();
            },
        },

        components: {
            toolbar: baseToolbar,
            partialListNavigation: partialListNavigation,
            switchLayout: switchLayout
        }
    }
</script>
